
export default (axios) => ({
	getAll() {
		return axios.get("/payDirectApiLogs")
	}
})